// ListCell Component

import PropTypes from 'prop-types'
import styled from 'styled-components'

const colors = {
  text: '#333'
}

const CellContainer = styled.div`
  color: ${colors.text};
  cursor: pointer;
  float: left;
  font-size: 15px;
  margin: 0 auto;
  overflow: hidden;
  padding: 19px 20px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ width }) => (width ? `width: ${width};` : '')}
`

CellContainer.propTypes = {
  width: PropTypes.string
}

export default CellContainer
